import { useState, useEffect, View, useRef } from 'react';
import { Button, Modal } from "react-bootstrap";
import axios from 'axios';
import CircularProgress from "@mui/material/CircularProgress";
//import { auth } from '../firebase';
import { useNavigate, useLocation } from 'react-router-dom';
import styles from './Forum.css';
import BottomTabNavigation from './BottomTabNavigation';
import Konsensus_Constants from '../constants/index.js';
import { Paper, Stack, Box } from "@mui/material";
import DOMPurify from "dompurify";
import he from "he";
import DeleteIcon from '@mui/icons-material/Delete';

export default function Notifications() {
  const scrollableDivRef = useRef(null);
  const navigate = useNavigate();
  const location = useLocation();
  const [notifications, setNotifications] = useState({});
  const [isFetching, setIsFetching] = useState(false);
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const [activeId, setActiveId] = useState(null);
  const [showOverlay, setShowOverlay] = useState(false);

  const checkLogin = async() => {
    if( window.location.href!='https://app.konsensus.tech/' && window.location.href!='https://app.dev.konsensus.tech/' && window.location.href!='https://app.accept.konsensus.tech/' && window.location.href!='https://app.accept.konsensus.tech/register' && window.location.href!='https://app.accept.konsensus.tech/forgotten_password'){
        try{
            let login_data = await Konsensus_Constants._retrieveDataLocal("login_response");
            // console.log("Checking login: "+JSON.stringify(login_data));
            if( login_data.login_response.data ){
                let res = await fetch(Konsensus_Constants.FORUM_URL+'/api/users?filter[self]=1&userId='+login_data.login_response.data.userId, {
                  headers: { 'Authorization': 'Token '+login_data.login_response.data.token }
                });
                // console.log(res);
                if (res.status !== 200) {
                  //alert('Session expired!');
                  Konsensus_Constants.clear();
                  navigate('/', { state: { message: "Either your login has expired or you haven't confirmed e-mail yet!" } });
                }
            }else{
              Konsensus_Constants.clear();
              navigate('/', { state: { message: "Either your login has expired or you haven't confirmed e-mail yet!" } });
            }
        } catch (error) {
          Konsensus_Constants.clear();
          console.error(error);
          navigate('/', { state: { message: "Either your login has expired or you haven't confirmed e-mail yet!" } });
        }
    }
    console.log(window.location.href);
  }

  setInterval(async () => {
    checkLogin();
  }, 5 * 60 * 1000); // every 5 minutes

  useEffect(() => {
    loadNotifications();
    fetchData();
  }, []);

  const loadNotifications = async () => {
    if( window.location.href!='https://app.konsensus.tech/' && window.location.href!='https://app.dev.konsensus.tech/' && window.location.href!='https://app.accept.konsensus.tech/' && window.location.href!='https://app.accept.konsensus.tech/register' && window.location.href!='https://app.accept.konsensus.tech/forgotten_password'){
        const AXIOS_CONFIG = {
            headers: {
                'Content-Type':'application/json'
            }
        }
        let nem = await Konsensus_Constants._retrieveDataLocal("nem");
        //console.log(nem)
        if( nem && nem.nem && nem.nem.data ){
            try{
                let response3 = await axios.post(Konsensus_Constants.NEM_URL+'/NEM/api/api.php/notifications', {userhash: nem.nem.data.userhash}, AXIOS_CONFIG);
                if( response3.data.error ){
                   //alert(response3.data.error);
                   console.log(response3.data.error);
                   if( response3.data.error === "No notifications" ){
                        setNotifications(null);
                        Konsensus_Constants._storeData("nem_notifications",null);
                   }
                }else{
                   //console.log(response3);
                   Konsensus_Constants._storeData("nem_notifications",response3);
                   fetchData();
                }
            }catch( error ){
                console.log(error);
            }
        }
        setTimeout(loadNotifications, 60000);
    }
  }

  const deleteNotification = async (id, title) => {
    if (window.confirm("Are you sure you want to delete "+title+"?")) {
        const AXIOS_CONFIG = {
            headers: {
                'Content-Type':'application/json'
            }
        }
        let response3 = await axios.post(Konsensus_Constants.NEM_URL+'/NEM/api/api.php/delete-notification', {id: id}, AXIOS_CONFIG);
        if( response3.data.error ){
           alert(response3.data.error);
        }else{
           console.log(response3);
           loadNotifications();
        }
    }
  }

    const fetchData = async () => {
  if( window.location.href!='https://app.konsensus.tech/' && window.location.href!='https://app.dev.konsensus.tech/' && window.location.href!='https://app.accept.konsensus.tech/' && window.location.href!='https://app.accept.konsensus.tech/register' && window.location.href!='https://app.accept.konsensus.tech/forgotten_password'){
          // setIsFetching(true);
          try {
            let login_data = await Konsensus_Constants._retrieveDataLocal("login_response")
            // console.log(login_data)
            let notifications = await Konsensus_Constants._retrieveDataLocal("nem_notifications");
            setNotifications(notifications);
          } catch (error) {
            console.error(error);
          }
      }
    };

  function RawHTMLExample({viewed, htmlString }) {
    let cleanHtml = DOMPurify.sanitize(he.decode(htmlString));
    cleanHtml = cleanHtml.replace(/\n/g, "<br />");
    //console.log("Viewed: "+viewed);
    return <div style={viewed==='1' ? { color: "#c9c9c9" } : {}} dangerouslySetInnerHTML={{ __html: cleanHtml }} />;
  }

  return (
    <Box sx={{
                 height: "100vh", // Fill viewport height
                 display: "flex",
                 flexDirection: "column",
               }}>
      {/*<Paper elevation={3} sx={{ p: 2 }}>
          <img src={require('../assets/images/banner.png')}
                        style={{
                           height: 97,
                           width: 380,
                           marginBottom: 0,
                        }}/>
      </Paper>*/}
       <Paper elevation={3} sx={{ p: 2 }}>
           <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
             <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
               <img src={require('../assets/images/banner.png')}
                             style={{
                              height: 97,
                              width: 380,
                              marginBottom: 0,
                              marginTop: 20,
                             }}/>
             </div>
             <div style={{ display: 'flex', gap: 8 }}>
             </div>
           </div>
       </Paper>
      <Paper elevation={3}
                     sx={{
                       flex: 1,        // fill all available vertical space
                       width: "100%",  // fill horizontal space
                       p: 2,
                     }}>
          <div style={{paddingBottom: 40}}>
          { notifications && notifications.nem_notifications && notifications.nem_notifications.data.data &&
            notifications.nem_notifications.data.data.map((item, index) => {
              return (
                              <div key={item.id} style={styles.post}>
                                <div style={styles.userContainer}>
                                    <div style={{float:"right"}}><button onClick={() => deleteNotification(item.id,item.title)} style={{ background: 'none', border: 'none', cursor: 'pointer' }}>
                                      <DeleteIcon color="#00aaaf" style={{ color: '#00aaaf' }} />
                                    </button></div>
                                    <div key={index} onMouseEnter={() => setHoveredIndex(index)}
                                       onMouseLeave={() => setHoveredIndex(null)} style={{
                                       background: hoveredIndex === index ? "#e7f4f6" : "#fff",
                                       color: hoveredIndex === index ? "#00aaaf" : "#00aaaf", }}
                                       onClick={() => {
                                          setActiveId(item.id);
                                          navigate("/notifications/"+item.id);
                                        }
                                       }
                                       className="forum-item">
                                      <div style={{float:"left"}}><RawHTMLExample viewed={item.viewed} htmlString={item.title || ''} /></div> <div style={{fontSize: 10,float:'left',},item.viewed==='1' ? { color: "#c9c9c9" } : {}}>&nbsp;- {new Date(item.notificationDate).toLocaleString()} </div>
                                    </div>
                               </div>
                              </div>
                      );
            })
          }
          </div>
      </Paper>
      <BottomTabNavigation />
    </Box>
  );
}
const styles2 = {
  container: { padding: 16, paddingTop:10, flex: 1 },
  commentCount: { fontSize: 16, marginBottom: 14 },
  postsContainer: { marginTop: 10 },
  post: { marginBottom: 22 },
  userContainer: { flexDirection: 'row', alignItems: 'center', marginBottom: 4 },
  avatar: { width: 36, height: 36, borderRadius: 18, marginRight: 10, backgroundColor: '#e7f4f6', float: "left", display: 'flex', alignItems: 'center', justifyContent: 'center',},
  avatarPlaceholder: { backgroundColor: '#e7f4f6', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#00aaaf', },
  userInfo: { flexDirection: 'column' },
  username: { fontSize: 16, fontWeight: '600' },
  postMeta: { fontSize: 12, color: '#888' },
  hr: { height: 1, backgroundColor: '#ddd', marginTop: 8, marginBottom: 4 },
};